export default function CollapseOne() {
    return (
        <div className="flex flex-col my-2 gap-4">
            <p>Donepecilo está contraindicado en pacientes con hipersensibilidad conocida al clorhidrato de Donepecilo o
                a sus derivados, o cualquier componente de la fórmula. No se usa en el embarazo ni en la lactancia.</p>
        </div>
    )
        ;
}